import { SITE_URL } from '@goodfellas/environment'

/**
 * Origem (atribuição) propagada nos links compartilháveis. Apenas propagação
 * nesta issue (#822); a persistência no cadastro e os eventos de funil ficam
 * na #821. Mantenha esta lista em paralelo com `sweep/lib/shared/utils/share_links.dart`.
 */
export type ShareRef =
  | 'web_card'
  | 'web_profile'
  | 'app_share'
  | 'app_profile'
  | 'app_challenge'
  | 'app_training'
  | 'story'

export type RequestKind = 'challenge' | 'training'

// Em produção `SITE_URL` aponta para `https://goodfellas.app/` (mesmo host dos
// App Links / Universal Links). Normaliza removendo a barra final.
const BASE = SITE_URL.replace(/\/+$/, '')

function withRef(path: string, ref?: ShareRef): string {
  const url = `${BASE}${path}`
  return ref ? `${url}?ref=${encodeURIComponent(ref)}` : url
}

/** Página pública por username/nickname: `/@<handle>` (o site também aceita a
 * forma nua `/<handle>` e redireciona). */
export const handleUrl = (username: string, ref?: ShareRef): string =>
  withRef(`/@${encodeURIComponent(username.trim())}`, ref)

export const fighterUrl = (
  id: string,
  ref?: ShareRef,
  username?: string,
): string =>
  username?.trim() ? handleUrl(username, ref) : withRef(`/fighters/${id}`, ref)

export const gymUrl = (id: string, ref?: ShareRef, username?: string): string =>
  username?.trim() ? handleUrl(username, ref) : withRef(`/gyms/${id}`, ref)

/** Convite de avaliação 360. `id` é o uuid do usuário (ou telefone, que o site
 * redireciona para o uuid correspondente). */
export const evaluateUrl = (id: string, ref?: ShareRef): string =>
  withRef(`/evaluate/${id}`, ref)

export const challengeUrl = (id: string, ref?: ShareRef): string =>
  withRef(`/challenges/requests/${id}`, ref)

export const trainingUrl = (id: string, ref?: ShareRef): string =>
  withRef(`/trainings/requests/${id}`, ref)

/** Escolhe o path canônico do request pelo tipo (desafio vs treino). Ambos
 * abrem a mesma tela de detalhes no app. */
export const requestUrl = (
  id: string,
  kind: RequestKind,
  ref?: ShareRef,
): string =>
  kind === 'challenge' ? challengeUrl(id, ref) : trainingUrl(id, ref)
